(function () {
  'use strict';
  function init() {
    var root = document.getElementById('ProductSection');
    if (!root || root.dataset.gtuGalleryBound) return;
    var productNode = document.getElementById('ProductJson-' + root.dataset.sectionId) || document.querySelector('[id^="ProductJson-"]');
    var groupNode = document.getElementById('GtuVariantImageGroups');
    if (!productNode || !groupNode) return;
    var product = JSON.parse(productNode.textContent);
    var showAllMedia = product.type === 'Mattress';
    var groups = JSON.parse(groupNode.textContent) || {};
    if (product.variants.length === 1 && !Array.isArray(groups[String(product.variants[0].id)])) return;
    var imageMapNode = document.getElementById('GtuMediaImageIds');
    var imageMap = imageMapNode ? JSON.parse(imageMapNode.textContent) : {};
    var master = root.querySelector('.product-single__variants');
    var wrappers = Array.prototype.slice.call(root.querySelectorAll('.product-single__photos > .product-single__image-wrapper[data-image-id]'));
    var thumbnails = Array.prototype.slice.call(root.querySelectorAll('.product-single__thumbnail[data-image-id]'));
    var previous = null;
    var controls = [];
    var heading = root.querySelector('h1[itemprop="name"]');
    var baseTitle = product.title || (heading ? heading.textContent.trim() : '');
    var colorIndex = (product.options || []).findIndex(function (name) { return /color|colour|finish/i.test(name); });
    if (colorIndex > -1) {
      product.variants.map(function (v) { return v.options[colorIndex]; }).filter(Boolean).sort(function (a, b) { return b.length - a.length; }).some(function (color) {
        var suffix = ' ' + color.toLowerCase();
        if (baseTitle.toLowerCase().slice(-suffix.length) !== suffix) return false;
        baseTitle = baseTitle.slice(0, -suffix.length).replace(/\s*[–-]$/, '').trim();
        return true;
      });
    }
    function selectors() { return Array.prototype.slice.call(root.querySelectorAll('select.single-option-selector')); }
    function selectedVariant() {
      if (product.variants.length === 1) return product.variants[0];
      var options = selectors();
      if (options.length) return product.variants.filter(function (v) {
        return v.options && v.options.every(function (value, i) { return options[i] && value === options[i].value; });
      })[0];
      var id = master ? String(master.value) : '';
      return product.variants.filter(function (v) { return String(v.id) === id; })[0];
    }
    function buildControls() {
      if (controls.length || product.variants.length < 2) return;
      selectors().forEach(function (select, index) {
        var field = document.createElement('fieldset');
        field.className = 'gtu-option-buttons';
        var legend = document.createElement('legend');
        legend.textContent = product.options[index];
        field.appendChild(legend);
        var grid = document.createElement('div');
        grid.className = 'gtu-option-grid';
        field.appendChild(grid);
        Array.prototype.forEach.call(select.options, function (option, optionIndex) {
          var label = document.createElement('label');
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = 'gtu-option-' + root.dataset.sectionId + '-' + index;
          input.value = option.value;
          var text = document.createElement('span');
          text.textContent = option.textContent;
          label.appendChild(input);
          label.appendChild(text);
          grid.appendChild(label);
          input.addEventListener('change', function () {
            var options = selectors();
            select.value = input.value;
            var exact = selectedVariant();
            if (!exact) {
              var candidates = product.variants.filter(function (v) {
                return v.options.every(function (value, i) { return i > index || value === options[i].value; });
              });
              var next = candidates.filter(function (v) { return v.available; })[0] || candidates[0];
              if (next) options.forEach(function (el, i) { el.value = next.options[i]; });
            }
            // Keep the original theme responsible for price, stock and cart state.
            options.forEach(function (el) { el.dispatchEvent(new Event('change', { bubbles: true })); });
            sync();
          });
        });
        select.parentElement.insertBefore(field, select);
        select.hidden = true;
        select.style.display = 'none';
        var oldLabel = select.parentElement.querySelector('label[for="' + select.id + '"]');
        if (oldLabel) oldLabel.hidden = true;
        controls.push({ field: field, select: select, index: index });
      });
    }
    function syncControls() {
      var options = selectors();
      controls.forEach(function (control) {
        control.field.querySelectorAll('input').forEach(function (input) {
          var candidates = product.variants.filter(function (v) {
            return v.options[control.index] === input.value && v.options.every(function (value, i) {
              return i >= control.index || value === options[i].value;
            });
          });
          var soldOut = candidates.length > 0 && !candidates.some(function (v) { return v.available; });
          input.checked = input.value === control.select.value;
          input.disabled = candidates.length === 0;
          input.parentElement.classList.toggle('is-unavailable', input.disabled || soldOut);
          input.setAttribute('aria-label', input.value + (soldOut ? ' - Sold out' : input.disabled ? ' - Unavailable' : ''));
        });
      });
    }
    root.dataset.gtuGalleryBound = 'true';
    var message = document.createElement('p');
    message.textContent = 'Images for this option are not available.';
    message.setAttribute('role', 'status');
    message.hidden = true;
    wrappers[0] && wrappers[0].parentElement.appendChild(message);
    function setHidden(element, hidden) {
      if (hidden) element.setAttribute('data-gtu-group-hidden', 'true');
      else element.removeAttribute('data-gtu-group-hidden');
      element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    }
    function sync() {
      buildControls();
      var variant = selectedVariant();
      var id = variant ? String(variant.id) : '';
      syncControls();
      if (heading && colorIndex > -1 && variant) heading.textContent = baseTitle + ' – ' + variant.options[colorIndex];
      if (showAllMedia) {
        wrappers.forEach(function (w) { setHidden(w, false); });
        thumbnails.forEach(function (a) {
          setHidden(a, false);
          var item = a.closest('li') || a;
          setHidden(item, false);
          item.style.removeProperty('display');
        });
        root.querySelectorAll('.gallery__item[data-image-id]').forEach(function (a) { setHidden(a, false); });
        message.hidden = true;
        previous = id;
        return;
      }
      var allowed = groups[id];
      if (Array.isArray(allowed)) allowed = allowed.map(function (key) { return String(imageMap[key] || key); });
      else allowed = variant && variant.featured_image ? [String(variant.featured_image.id)] : [];
      var active = wrappers.filter(function (w) { return allowed.indexOf(w.getAttribute('data-image-id')) !== -1; });
      wrappers.forEach(function (w) { setHidden(w, active.indexOf(w) === -1); });
      thumbnails.forEach(function (a) {
        var hidden = allowed.indexOf(a.getAttribute('data-image-id')) === -1;
        setHidden(a, hidden);
        var item = a.closest('li') || a;
        setHidden(item, hidden);
        item.style.removeProperty('display');
      });
      root.querySelectorAll('.gallery__item[data-image-id]').forEach(function (a) { setHidden(a, allowed.indexOf(a.getAttribute('data-image-id')) === -1); });
      message.hidden = active.length > 0;
      if (active.length && (previous !== id || !active.some(function (w) { return !w.classList.contains('hide'); }))) {
        var lead = active.filter(function (w) { return w.getAttribute('data-image-id') === allowed[0]; })[0] || active[0];
        wrappers.forEach(function (w) { w.classList.toggle('hide', w !== lead); });
        var img = lead.querySelector('.product-single__image');
        if (img && !img.getAttribute('src') && img.dataset.src) img.src = img.dataset.src.replace('{width}', '900');
        lead.parentElement.insertBefore(lead, lead.parentElement.firstElementChild);
      }
      previous = id;
    }
    root.addEventListener('change', function (event) {
      if (event.target.matches('.single-option-selector, .product-single__variants')) window.setTimeout(sync, 0);
    });
    window.addEventListener('popstate', function () {
      var id = new URL(window.location.href).searchParams.get('variant');
      if (id && master && product.variants.some(function (v) { return String(v.id) === id; })) {
        var variant = product.variants.filter(function (v) { return String(v.id) === id; })[0];
        var options = selectors();
        options.forEach(function (el, i) { el.value = variant.options[i]; el.dispatchEvent(new Event('change', { bubbles: true })); });
        if (!options.length) { master.value = id; if (window.jQuery) window.jQuery(master).trigger('change'); }
      }
      window.setTimeout(sync, 0);
    });
    sync();
    window.setTimeout(sync, 100);
    window.setTimeout(sync, 500);
    window.setTimeout(sync, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}());

